import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { LanguageProvider } from "@/context/LanguageContext";
import { SiteProvider } from "@/context/SiteContext";
import { Navbar } from "@/components/Navbar";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { Footer } from "@/components/Footer";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Listings from "@/pages/Listings";
import Neighborhoods from "@/pages/Neighborhoods";
import NeighborhoodDetail from "@/pages/NeighborhoodDetail";
import Developments from "@/pages/Developments";
import Valuation from "@/pages/Valuation";
import Testimonials from "@/pages/Testimonials";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);
  return null;
};

function App() {
  return (
    <LanguageProvider>
      <SiteProvider>
      <BrowserRouter>
        <SmoothScroll />
        <ScrollToTop />
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/listings" element={<Listings />} />
            <Route path="/neighborhoods" element={<Neighborhoods />} />
            <Route path="/neighborhoods/:slug" element={<NeighborhoodDetail />} />
            <Route path="/developments" element={<Developments />} />
            <Route path="/valuation" element={<Valuation />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Footer />
        </div>
        <Toaster position="top-center" richColors />
        <WhatsAppButton />
      </BrowserRouter>
      </SiteProvider>
    </LanguageProvider>
  );
}

export default App;
